import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBowlingPins = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Regular",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "bowling-pins" }),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M14.25,8.25V3a2.25,2.25,0,0,0-4.5,0V8.25a11.476,11.476,0,0,0-3,7.5,11.418,11.418,0,0,0,2.509,6.933,1.5,1.5,0,0,0,1.175.567h3.132a1.5,1.5,0,0,0,1.175-.567A11.418,11.418,0,0,0,17.25,15.75,11.476,11.476,0,0,0,14.25,8.25Z"
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "cls-1",
			x: 9.75,
			y: 5.25,
			width: 4.5,
			height: 3
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M5.25,2.25a1.5,1.5,0,0,0-1.5,1.5v3h3v-3A1.5,1.5,0,0,0,5.25,2.25Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M5.25,21.75H3.75s-3-1.5-3-6.75a12.25,12.25,0,0,1,3-8.25h3"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M18.75,2.25a1.5,1.5,0,0,1,1.5,1.5v3h-3v-3A1.5,1.5,0,0,1,18.75,2.25Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M18.75,21.75h1.5s3-1.5,3-6.75a12.25,12.25,0,0,0-3-8.25h-3"
		})
	]
});
export default SvgBowlingPins;
